// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"hu-z","title":"iu-z","nav":"ju-z","flexCell":"ku-z","facetLink":"lu-z"};